import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { green, orange, red } from '@material-ui/core/colors';

interface StatusIndicatorProps {
  indicator: 'green' | 'orange' | 'red';
  variant?: 'circle' | 'table';
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    opacity: 0.8,
  },
  circleVariant: {
    display: 'inline-block',
    height: 12,
    width: 12,
    marginRight: theme.spacing(1),
    borderRadius: '50%',
    transform: 'translateY(1px)',
  },
  tableVariant: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: 4,
    height: '100%',
    borderRadius: 0,
  },
  green: {
    background: green[700],
  },
  orange: {
    background: orange[700],
  },
  red: {
    background: red[700],
  },
}));

const StatusIndicator = (props: StatusIndicatorProps) => {
  const { indicator, className } = props;
  const classes = useStyles();

  const variant = props.variant || 'circle';
  const variantClass = `${variant}Variant` as 'tableVariant' | 'circleVariant';

  return (
    <div
      className={`${classes.root} ${className} ${classes[variantClass]} ${classes[indicator]}`}
    />
  );
};

export default StatusIndicator;
